import PropTypes from "prop-types";

// Collapse continuous lines in a set of line ranges
// 1 => 1
// 1,2 => 1 - 2
// 1,2,3,4,6,7,8 => 1 - 4, 6 - 8

export default function ShowLines({
    lines,
}) {
    if (lines.length <= 1) {
        // shortcut for empty and one element arrays
        return lines.join('');
    }

    // push at the start of the lineGroups stack the current line range a line
    // group is an 2-array with the last line of the group and the first line
    // of the group
    return lines.slice(1)
        .reduce((lineGroups, value) => {
            const [ last ] = lineGroups[0];

            // line is the next one after the last, update the current group
            if ( value === last + 1 ) {
                lineGroups[0][0] = value;
            } else {
                // line is not  the next one after the last, insert a new group
                lineGroups.unshift([value, value]);
            }
            return lineGroups;
        }, [ [lines[0], lines[0]] ])
        // Reverse the list because the lines are inserted at the start
        .reverse()
        .map(([last, first]) => first !== last ? `${first} - ${last}` : String(first))
        .join(', ');
}

ShowLines.propTypes = {
    lines: PropTypes.arrayOf(PropTypes.number).isRequired,
};
